import { useApp } from "../store.jsx";
import { PriorityPill, StatusPill } from "../components/Pill.jsx";
import TaskEditor from "../components/TaskEditor.jsx";
import FinancialImpact from "../components/FinancialImpact.jsx";

export default function TaskPage({ id }) {
  const { tasks, meta } = useApp();
  if (!tasks || !meta) return <div className="container">Loading…</div>;

  const t = tasks.find(x => x.id === id);
  if (!t) return (
    <div className="container">
      <div className="crumb"><a href="#/">Overview</a></div>
      <p>Task <code>{id}</code> not found.</p>
    </div>
  );
  const info = meta.departments[t.deptShort];

  return (
    <div className="container">
      <div className="crumb">
        <a href="#/">Overview</a><span className="sep">/</span>
        <a href={"#/dept/"+t.deptShort}>{info.fullname}</a><span className="sep">/</span>
        #{t.briefNo} {t.title}
      </div>

      <section className="brief">
        <h1>{t.title}</h1>
        <div className="meta" style={{marginTop:10}}>
          <span className={"pill dept-"+t.deptShort}>{info.fullname}</span>
          <PriorityPill priority={t.priority} label={t.priorityLabel}/>
          <StatusPill status={t.status}/>
          <span style={{color:"#cbd5e1"}}>Owner: {t.owner||"—"}</span>
          <span style={{color:"var(--muted)"}}>Brief #{t.briefNo}</span>
        </div>
      </section>

      <TaskEditor task={t}/>
      <FinancialImpact task={t}/>

      <a className="anchorlink" href={"#/dept/"+t.deptShort}>← Back to {info.fullname}</a>
    </div>
  );
}
